const rotas = [
    {
        path: '/dashboard-posvendas',
        name: 'Dashboard Pós-vendas',
        component: () => import("@/views/PosVendas/Dashboard.vue"),
        meta: {
            obraObrigatoria: false,
            title: "Dashboard",
            icon: 'mdi-view-dashboard-outline',
            subject: ['POSVENDAS'],
            action: ['read'],
            showMenu: true,
            grupo: "POSVENDAS",
            grupoTitle: "Pós-vendas"
        },
    },
    {
        path: '/posvendas-satisfacao',
        name: 'Dashboard Satisfação de Pós-vendas',
        component: () => import("@/views/PosVendas/DashboardSatisfacao.vue"),
        meta: {
            obraObrigatoria: false,
            title: "Dashboard Satisfação",
            icon: 'mdi-monitor-star',
            subject: ['POSVENDAS'],
            action: ['read'],
            showMenu: true,
            grupo: "POSVENDAS",
            grupoTitle: "Pós-vendas"
        },
    },
    {
        path: '/posvendas',
        name: 'Tickets Pós-vendas',
        component: () => import("@/views/PosVendas/TodosTickets.vue"),
        meta: {
            title: "Todos Tickets",
            icon: 'mdi-account-switch-outline',
            subject: ['POSVENDAS'],
            showMenu: true,
            grupo: "POSVENDAS",
            grupoTitle: "Pós-vendas"
        },
    },
    {
        path: '/posvendas/os',
        name: 'Lista de OS Field Services',
        component: () => import("../../views/PosVendas/ListarOS.vue"),
        meta: {
            obraObrigatoria: true,
            breadcrumb: 'Pós-vendas',
            title: "Ordens de serviço Field Services",
            icon: 'mdi-list-status',
            subject: ['POSVENDAS'],
            action: ['read'],
            showMenu: true,
            grupo: "POSVENDAS",
            grupoTitle: "OS Field Services"
        },
    },
    {
        path: '/posvendas/os/:idOs/editar',
        name: 'Editar OS Pós-vendas',
        component: () => import("../../views/PosVendas/DadosOSPosVendas.vue"),
        meta: {
            obraObrigatoria: true,
            breadcrumb: 'Lista de OS Field Services',
            title: "Editar OS",
            icon: 'mdi-list-status',
            subject: ['POSVENDAS'],
            action: ['edit'],
            showMenu: false,
            grupo: "POSVENDAS",
            grupoTitle: "OS Field Services"
        },
    },
    {
        path: '/posvendas/:ticket',
        name: 'Ticket',
        component: () => import("@/views/PosVendas/Ticket.vue"),
        meta: {
            breadcrumb: 'Tickets Pós-vendas',
            title: "Ticket",
            icon: 'mdi-account-switch-outline',
            subject: ['POSVENDAS'],
            showMenu: false,
            grupo: "POSVENDAS",
            grupoTitle: "Pós-vendas"
        },
    },
]

export default rotas;